<template>
  <div :class="{ 'spacing-p-20': !isMobile }">
    <b-loading :active="isLoading" />
    <UnifiedFilterSearch
      :beforeMountFunction="getFilesPagesRequest"
      :activeTab="activeTab"
      :filterList="filterList"
      :itensFilter="getItemsFilter"
      :orderBy="orderBy"
      :tabPersistName="tabPersistName"
      @search-value="setFilterSearch"
      @filters="setFilterList"
      @orderValue="getOrderValue"
    />
    <div
      v-if="selectedDocument.length > 1 && showProcessFiles"
      class="batch-buttons"
    >
      <b-tooltip
        v-if="process.can_tramit"
        :type="isContrast ? 'is-white' : 'is-blue-oil'"
        size="is-large"
        position="is-top"
        multilined
        role="tooltip"
        :active="hasNoEffect"
      >
        <template v-slot:content>
          <label class="has-text-weight-semibold is-flex">{{
            App.MenuMain.HELP
          }}</label>
          <p class="has-text-left">
            {{ General.TEXTS.SELECT_NO_EFFECT_DOCUMENT }}
          </p>
        </template>
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          :disabled="hasNoEffect"
          role="button"
          :aria-description="General.ARIA_LABEL.DOCS_GIVE_KNOWLEDGE"
          @click.stop="validateBatchFile"
        >
          <label>{{ General.GIVE_KNOWLEDGE }}</label>
        </b-button>
      </b-tooltip>
      <b-tooltip
        v-if="process.can_tramit"
        multilined
        :type="isContrast ? 'is-white' : 'is-blue-oil'"
        size="is-large"
        position="is-top"
        role="tooltip"
        :active="unableSignBatch"
      >
        <template v-slot:content>
          <label class="has-text-weight-semibold is-flex">{{
            App.MenuMain.HELP
          }}</label>
          <p class="has-text-left">
            {{
              hasNoPublish
                ? General.TEXTS.NO_PROGRESS_PUBLISH_SIGNATURE_CURRENT_USER
                : hasSignCurrentUserDoc
                ? General.TEXTS.REMOVE_SIGNATURE_CURRENT_USER
                : General.TEXTS.UNABLE_TO_SIGN
            }}
          </p>
        </template>
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          :disabled="unableSignBatch"
          expanded
          role="button"
          :aria-description="General.ARIA_LABEL.DOCS_SIGN"
          @click.stop="signBatchDocument"
        >
          <label>{{ General.SIGN }}</label>
        </b-button>
      </b-tooltip>
      <b-tooltip
        v-if="process.can_tramit"
        multilined
        :type="isContrast ? 'is-white' : 'is-blue-oil'"
        size="is-large"
        position="is-top"
        :active="unableRequestSubscriptionBatch"
        role="tooltip"
      >
        <template v-slot:content>
          <label class="has-text-weight-semibold is-flex">{{
            App.MenuMain.HELP
          }}</label>
          <p class="has-text-left">
            {{
              hasNoPublish
                ? General.TEXTS.NO_PROGRESS_PUBLISH_REQUEST_SIGNATURE
                : General.TEXTS.UNABLE_TO_SIGN
            }}
          </p>
        </template>
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          :disabled="unableRequestSubscriptionBatch"
          expanded
          role="button"
          :aria-description="General.ARIA_LABEL.DOCS_REQUEST_SIGNATURE"
          @click.stop="requestSubscriptionBatchFile"
        >
          <label>{{ General.REQUEST_SUBSCRIPTION }}</label>
        </b-button>
      </b-tooltip>
      <b-button
        :type="isContrast ? 'is-white' : 'is-green-lawn'"
        role="button"
        :aria-description="General.ARIA_LABEL.DOCS_DOWNLOAD"
        @click.stop="checkIsConfidential(downloadBatchPDF)"
      >
        <label>{{ General.EXPORT_PDF }}</label>
      </b-button>
    </div>
    <nav class="tabs is-flex is-align-items-center">
      <b-checkbox
        v-if="showProcessFiles"
        v-model="checkAll"
        data-cy="CHECK_ALL_DOCUMENTS"
        :type="isContrast ? 'is-white' : 'is-blue-oil'"
        class="pr-10"
        role="checkbox"
      />
      <ul role="tablist">
        <li
          :class="{ 'is-active': activeTab == TABS.PROCESS_DOCUMENTS.value }"
          role="tab"
          @click="activeTab = TABS.PROCESS_DOCUMENTS.value"
        >
          <a class="tabs-title spacing-px-10">
            {{ General.PROCESS_DOCUMENTS }}
            <b-tag class="spacing-mx-10" rounded>
              {{ getProcessFilesCount }}
            </b-tag>
          </a>
        </li>
        <li
          :class="{ 'is-active': activeTab == TABS.EDITABLE_DOCUMENTS.value }"
          role="tab"
          @click="activeTab = TABS.EDITABLE_DOCUMENTS.value"
        >
          <a class="tabs-title spacing-px-10">
            {{ General.EDITABLE_DOCUMENTS }}
            <b-tag class="spacing-mx-10" rounded>
              {{ getProcessFilesEditableCount }}
            </b-tag>
          </a>
        </li>
        <li v-if="!isMobile" class="is-flex flex-1 is-justify-content-flex-end">
          <span>
            {{ getPaginationDetails }}
          </span>
        </li>
      </ul>
    </nav>
    <section>
      <b-loading :isFullPage="false" :active="isFetching" />
      <section v-show="showProcessFiles">
        <div
          v-for="document in filteredFiles"
          :key="document.id"
          class="is-flex is-full"
          :class="{ 'is-align-items-flex-start': isMobile }"
          role="tabpanel"
        >
          <b-checkbox
            v-model="selectedDocument"
            :type="isContrast ? 'is-white' : 'is-blue-oil'"
            class="pr-10"
            :class="{ 'mt-20': isMobile }"
            :nativeValue="document"
          />
          <DocumentDetails
            :process="process"
            :document="document"
            :userId="userId"
            :isUserResponsable="isUserResponsable"
            :isAppendedProcess="isAppendedProcess"
            :isConfidential="isConfidential"
          />
        </div>
      </section>
      <section v-show="activeTab !== TABS.PROCESS_DOCUMENTS.value">
        <div
          v-for="document in filteredEditableFiles"
          :key="document.id"
          class="is-flex is-full"
          role="tabpanel"
        >
          <DocumentDetails
            :process="process"
            :document="document"
            :userId="userId"
            :isUserResponsable="isUserResponsable"
            isEditable
            :isAppendedProcess="isAppendedProcess"
            :isConfidential="isConfidential"
          />
        </div>
      </section>
      <NoListMessage v-if="!isFetching && !processFilesCount" />
      <footer>
        <div class="is-flex table-footer gap-10 mt-20">
          <span class="has-text-black has-text-weight-normal">
            <b-dropdown
              v-model="perPage"
              role="listbox"
              expanded
              position="is-top-right"
            >
              <template slot="trigger">
                <b-button class="custom-dropdown-button custom-ph-8">
                  <label
                    >{{ perPage }} {{ General.PER_PAGE.toLowerCase() }}</label
                  >

                  <b-icon class="spacing-mx-5" icon="chevron-down" />
                </b-button>
              </template>
              <div class="has-text-color-8 spacing-p-5 has-text-centered">
                {{ General.RECORDS_FOR_PAGE }}
                <div class="list-page">
                  <b-dropdown-item
                    v-for="option in optionsPagination"
                    :key="option"
                    :value="option"
                    role="listitem"
                  >
                    <div>
                      {{ option }}
                    </div>
                  </b-dropdown-item>
                </div>
              </div>
            </b-dropdown>
          </span>
          <div class="is-justify-content-space-around is-flex flex-1">
            <b-pagination
              :total="processFilesCount"
              :perPage="perPage"
              :current.sync="currentPage"
              rangeBefore="1"
              rangeAfter="1"
              order="is-centered"
              class="process-panel-pagination"
              rounded
              :iconPrev="prevIcon"
              :iconNext="nextIcon"
              :aria-next-label="General.NEXT_PAGE"
              :aria-previous-label="General.PREVIOUS_PAGE"
              :aria-page-label="General.PAGE"
              :aria-current-label="General.CURRENT_PAGE"
              role="navigation"
            />
          </div>
          <PageByNumber v-model="currentPage" :numberOfPages="pageCount" />
        </div>
      </footer>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { App, General } from "@/utils/constants";
import DocumentDetails from "@/components/DocumentDetails";
import NoListMessage from "@/components/NoListMessage";
import {
  PROCESS_DETAILS_DOC_TABS as TABS,
  TAB_PERSIST_NAME as PERSIST_NAME,
  DOC_SIGNATURES_STATUS as DOC_SIGN,
  USER_PERMISSIONS as userPermissions,
  LIST_TYPE as listType,
  MAX_SIGN_SIZE
} from "@/utils/enumerate";
import { exportFilesPDF } from "@/utils/fileUtility";
import UnifiedFilterSearch from "@/components/UnifiedFilterSearch";
import PageByNumber from "@/components/PageByNumber";
import ModalSignDocument from "@/views/App/ModalSignDocument";
import ModalDocSignature from "@/views/App/ModalDocSignature";
import ModalSelectUser from "@/views/App/ModalSelectUser";
import ModalWarning from "@/views/App/ModalWarning.vue";
import { createFilterData } from "@/utils/filters";
import { formatPagination } from "@/utils/transformers";
import { debounce } from "lodash";
import { setPersistSort, getPersistSort } from "@/plugins/indexDB";

export default {
  name: "ProcessDetailsDocumentContent",

  components: {
    DocumentDetails,
    NoListMessage,
    UnifiedFilterSearch,
    PageByNumber
  },

  props: {
    process: {
      required: true,
      type: Object
    },
    userId: {
      required: true,
      type: Number
    },
    isUserResponsable: {
      type: Boolean,
      default: false
    },
    isAppendedProcess: {
      type: Boolean,
      default: false
    },
    isConfidential: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      App,
      General,
      TABS,
      DOC_SIGN,
      listType,
      activeTab: TABS.PROCESS_DOCUMENTS.value,
      orderBy: "sequence",
      fileSearch: "",
      selectedDocument: [],
      checkAll: false,
      isLoading: false,
      isFetching: false,
      perPage: 10,
      currentPage: 1,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      filterList: {}
    };
  },

  computed: {
    ...mapGetters({
      getProcessFiles: "getProcessFiles",
      getProcessFilesCount: "getProcessFilesCount",
      getProcessFilesEditable: "getProcessFilesEditable",
      getProcessFilesEditableCount: "getProcessFilesEditableCount",
      getFileTypeById: "getFileTypeById",
      optionsPagination: "getItensPage",
      getUpdatedDataStatus: "getUpdatedDataStatus",
      getCurrentUser: "getCurrentUser",
      hasPermission: "hasPermission",
      isMobile: "isMobile",
      isContrast: "isContrast"
    }),
    pageCount() {
      return Math.ceil(this.processFilesCount / this.perPage);
    },
    showProcessFiles() {
      return this.activeTab === this.TABS.PROCESS_DOCUMENTS.value;
    },
    processFiles() {
      return this.showProcessFiles
        ? this.getProcessFiles
        : this.getProcessFilesEditable;
    },
    processFilesCount() {
      return this.showProcessFiles
        ? this.getProcessFilesCount
        : this.getProcessFilesEditableCount;
    },
    filteredFiles() {
      return this.getProcessFiles.filter(
        file => file.process_id === this.process.id
      );
    },
    filteredEditableFiles() {
      return this.getProcessFilesEditable.filter(
        file => file.process_id === this.process.id
      );
    },

    hasLargeFile() {
      return this.selectedDocument.some(doc => doc.filesize > MAX_SIGN_SIZE);
    },

    hasSignCurrentUserDoc() {
      return this.selectedDocument.some(doc =>
        doc.sign_history.some(
          history =>
            !history.only_historical &&
            history.status === this.DOC_SIGN.SIGNED &&
            history.user_id === this.getCurrentUser.id
        )
      );
    },
    hasNoPublish() {
      return this.selectedDocument.some(
        doc =>
          !["TO_PUBLISH", "REFUSED", "NOT_TO_PUBLISH"].includes(
            doc.current_doe_status
          )
      );
    },
    hasNoEffect() {
      return this.selectedDocument.some(doc => doc.no_effect);
    },
    unableRequestSubscriptionBatch() {
      return this.hasNoPublish || this.hasLargeFile || this.hasNoEffect;
    },
    unableSignBatch() {
      return this.hasSignCurrentUserDoc || this.unableRequestSubscriptionBatch;
    },
    getPaginationDetails() {
      return formatPagination(
        { count: this.processFilesCount },
        this.currentPage,
        this.perPage,
        "SIMPLIFIED"
      );
    },
    getItemsFilter() {
      return [
        "DOCUMENT_ORIGIN_PART",
        "DOCUMENT_ORIGIN_CAPACITY",
        "DOCUMENT_USER_DOCUMENT",
        "DOCUMENT_TYPE",
        "DOCUMENT_STATUS_SIGNATURE",
        "DOCUMENT_STATUS_DOE",
        "DOCUMENT_PROCESS_FILE_PAGE"
      ];
    },
    filterData() {
      return createFilterData(this.filterList);
    },
    requestBaseData() {
      return {
        processId: this.process.id,
        page: this.currentPage,
        search: this.fileSearch,
        paginator_count: this.perPage,
        order_by: this.orderBy,
        filters: this.filterData
      };
    },
    tabPersistName() {
      return `${PERSIST_NAME.PROCESS_DETAIL_DOCUMENTS}_${this.getCurrentUser.id}`;
    },
    hasPermissionViewConfidential() {
      return this.hasPermission(userPermissions["VIEW_CONFIDENTIAL_PROCESS"]);
    }
  },

  watch: {
    fileSearch() {
      if (this.currentPage === 1) this.refreshProcessFile();
      else this.currentPage = 1;
    },
    currentPage() {
      this.refreshProcessFile();
    },
    perPage() {
      if (this.currentPage === 1) this.refreshProcessFile();
      else this.currentPage = 1;
    },
    filterData() {
      if (this.currentPage === 1) this.refreshProcessFile();
      else this.currentPage = 1;
    },
    activeTab() {
      this.checkAll = false;
      const newOrderBy =
        this.activeTab == TABS.PROCESS_DOCUMENTS.value ? "sequence" : "date";
      this.selectedDocument = [];
      if (this.orderBy === newOrderBy) {
        this.refreshProcessFile();
      }
      this.orderBy = newOrderBy;
    },
    checkAll(value) {
      if (value) this.selectedDocument = this.filteredFiles;
      else this.selectedDocument = [];
    },
    selectedDocument(value) {
      const checkAllItens = value.length == this.filteredFiles.length;
      let status = -1;
      if (checkAllItens) status = checkAllItens;
      else if (value.length === 0) status = false;

      if (status !== -1 && this.checkAll !== status) this.checkAll = status;
    },
    filteredFiles() {
      this.selectedDocument = [];
    },
    getUpdatedDataStatus({ functionality }) {
      if (functionality === "process_files") this.requestProcessFileByType();
      else if (functionality === "process_files_editable")
        this.requestProcessFileByType(true);
    },
    orderBy(sort) {
      setPersistSort({ name: this.tabPersistName, sort });
      if (this.currentPage === 1) this.refreshProcessFile();
      else this.currentPage = 1;
    }
  },

  async created() {
    this.observerPage = false;
    const sortData = await getPersistSort({
      name: this.tabPersistName,
      sort: this.orderBy
    });
    this.observerPage = true;
    if (sortData !== this.orderBy) {
      this.orderBy = sortData;
    } else {
      this.requestProcessFileByType();
    }
  },
  beforeMount() {
    this.refreshProcessFile(true);
  },

  methods: {
    ...mapActions({
      requestFile: "requestDataProcessFile",
      processFileRequest: "processFileRequest",
      requestProcessFiles: "processFilesFilteredRequest",
      getFilesPages: "processFilePageRequest"
    }),
    ...mapMutations(["setListSelectedDocuments", "setCurrentProcessFileList"]),
    handleDocumentSelectedSign() {
      this.setListSelectedDocuments({
        documents: this.selectedDocument.map(doc => ({
          process_file: {
            ...doc,
            document_type: {
              description: this.getFileTypeById(doc.document_type).type
            },
            process: {
              nup: this.process.nup || General.TEXTS.NUP_NOT_GENERATED
            }
          }
        })),
        capacity_id: this.getCurrentUser.capacity.capacity_id
      });
    },
    signBatchDocument() {
      this.handleDocumentSelectedSign();

      this.$buefy.modal.open({
        parent: this,
        component: ModalSignDocument,
        props: { currentType: this.listType.BATCH_SIGN_FILES },
        hasModalCard: true,
        trapFocus: true
      });
    },
    requestProcessFile: debounce(async function(only_count = undefined) {
      this.isFetching = true;
      await this.processFileRequest({
        ...this.requestBaseData,
        only_count
      });
      this.isFetching = false;
    }, 1e3),
    async requestProcessFileEditable(only_count = undefined) {
      this.isFetching = true;
      await this.processFileRequest({
        ...this.requestBaseData,
        only_count,
        editable: true
      });
      this.isFetching = false;
    },
    async requestProcessFileByType(editable = false, only_count = undefined) {
      if (editable) await this.requestProcessFileEditable(only_count);
      else this.requestProcessFile(only_count);
    },
    async refreshProcessFile(all = false) {
      this.isFetching = true;

      const awaitRequests = [];
      if (all) {
        awaitRequests.push(() =>
          this.requestProcessFileByType(this.showProcessFiles, true)
        );
      }
      if (this.observerPage)
        awaitRequests.push(() =>
          this.requestProcessFileByType(!this.showProcessFiles)
        );
      await Promise.allSettled(awaitRequests.map(fn => fn()));
      this.selectedDocument = [];
      this.isFetching = false;
    },
    async validateBatchFile() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalSelectUser,
        props: {
          fileIds: this.selectedDocument,
          process: { id: this.process.id },
          updateFiles: async () => {
            this.isLoading = true;
            await this.requestProcessFiles({
              files_id: this.selectedDocument.map(file => file.id),
              processId: this.process.id
            });
            this.isLoading = false;
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },
    requestSubscriptionBatchFile() {
      this.setCurrentProcessFileList(this.selectedDocument);

      this.$buefy.modal.open({
        parent: this,
        component: ModalDocSignature,
        props: {
          processId: this.process.id,
          updateFiles: async () => {
            this.isLoading = true;
            await this.requestProcessFiles({
              files_id: this.selectedDocument.map(file => file.id),
              processId: this.process.id
            });
            this.isLoading = false;
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },
    async downloadBatchPDF() {
      this.isLoading = true;
      const result = await this.requestFile({
        fileIds: this.selectedDocument.map(doc => ({
          process_file_id: doc.id
        })),
        processId: this.process.id
      });

      if (result) {
        await exportFilesPDF(result, this.process.nup);
        this.selectedDocument = [];
      }
      this.isLoading = false;
    },
    setFilterSearch(value) {
      this.fileSearch = value;
    },
    setFilterList(filterList) {
      this.filterList = filterList;
    },
    getOrderValue(value) {
      this.orderBy = value;
    },
    getFilesPagesRequest() {
      this.getFilesPages(this.process.id);
    },
    validateConfidentialView() {
      if (!this.hasPermissionViewConfidential) {
        this.snackToast.open({
          message: this.General.TEXTS.CONFIDENTIAL_VIEW_WARNING,
          position: "is-top",
          type: "is-warning",
          duration: 8000
        });
        return false;
      }
      return true;
    },
    checkIsConfidential(callback = () => null) {
      if (this.isConfidential) {
        const hasConfidentialPermission = this.validateConfidentialView();
        if (!hasConfidentialPermission) return;

        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: `${this.General.WARNING}!`,
            message: this.General.MESSAGES.ALERT_DOCUMENT_SECRECY,
            invertOutline: true,
            confirm: callback,
            buttons: [
              { label: General.YES, isConfirm: true, action: true },
              { label: General.NO, isConfirm: false, action: false }
            ]
          },
          hasModalCard: true,
          trapFocus: true
        });
      } else {
        callback();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.title-columns {
  margin-top: 20px;
  margin-bottom: -20px;
}

.custom-justify-flex-end {
  display: flex;
  justify-content: flex-end;
}

.custom-pagination-boder {
  border-bottom: 1px solid #dbdbdb;
}

.batch-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 5px;

  @media screen and (max-width: $tablet) {
    flex-direction: column;
  }
}
</style>
